import { PropsWithChildren } from "react";
import { Paper } from "@mui/material";

interface ConditionalSeparatorProps {
  id?: string;
  additionalClasses?: string;
}

export function PropertyGroup(props: PropsWithChildren<ConditionalSeparatorProps>) {
  return (
    <Paper elevation={3} className={"property-group-wrap " + props.additionalClasses} id={props.id}>
      {props.children}
    </Paper>
  );
}
